import { render, staticRenderFns } from "./TeklifOnayi.vue?vue&type=template&id=2a1f7e89&"
import script from "./TeklifOnayi.vue?vue&type=script&lang=js&"
export * from "./TeklifOnayi.vue?vue&type=script&lang=js&"
import style0 from "./TeklifOnayi.vue?vue&type=style&index=0&id=2a1f7e89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports